import { connect } from 'react-redux'
import NotFoundComponent from './components/NotFoundComponent'

const mapDispatchToProps = {}

const mapStateToProps = (state) => ({})

export default connect(mapStateToProps, mapDispatchToProps)(NotFoundComponent)



// WEBPACK FOOTER //
// ./src/components/NotFoundComponent/index.js